import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';
import WaitlistCapture from './WaitlistCapture';

const FinalCTASection = ({ onRegisterClick, onLoginClick }) => {
  const { t } = useTranslation();

  return (
    <section className="py-24 bg-primary relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0zNiAxOGMzLjMxNCAwIDYgMi42ODYgNiA2cy0yLjY4NiA2LTYgNi02LTIuNjg2LTYtNiAyLjY4Ni02IDYtNnptMCAxMmMzLjMxNCAwIDYgMi42ODYgNiA2cy0yLjY4NiA2LTYgNi02LTIuNjg2LTYtNiAyLjY4Ni02IDYtNnptMC0yNGMzLjMxNCAwIDYgMi42ODYgNiA2cy0yLjY4NiA2LTYgNi02LTIuNjg2LTYtNiAyLjY4Ni02IDYtNnptMTIgMTJjMy4zMTQgMCA2IDIuNjg2IDYgNnMtMi42ODYgNiA2IDYtNi0yLjY4Ni02LTYgMi42ODYtNiA2LTZ6bTAgMTJjMy4zMTQgMCA2IDIuNjg2IDYgNnMtMi42ODYgNi02IDYtNi0yLjY4Ni02LTYgMi42ODYtNiA2LTZ6bTAtMjRjMy4zMTQgMCA2IDIuNjg2IDYgNnMtMi42ODYgNi02IDYtNi0yLjY4Ni02LTYgMi42ODYtNiA2LTZ6TTI0IDE4YzMuMzE0IDAgNiAyLjY4NiA2IDZzLTIuNjg2IDYtNiA2LTYtMi42ODYtNi02IDIuNjg2LTYgNi02em0wIDEyYzMuMzE0IDAgNiAyLjY4NiA2IDZzLTIuNjg2IDYtNiA2LTYtMi42ODYtNi02IDIuNjg2LTYgNi02em0wLTI0YzMuMzE0IDAgNiAyLjY4NiA2IDZzLTIuNjg2IDYtNiA2LTYtMi42ODYtNiA2IDIuNjg2LTYgNi02em0xMiAxMmMzLjMxNCAwIDYgMi42ODYgNiA2cy0yLjY4NiA2LTYgNi02LTIuNjg2LTYtNiAyLjY4Ni02IDYtNnoiIHN0cm9rZT0iI0ZGRiIgc3Ryb2tlLXdpZHRoPSIyIi8+PC9nPjwvc3ZnPg==')] animate-pulse" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
          {t('landing.finalCta.title')}
        </h2>
        <p className="text-xl text-primary-foreground/80 mb-10 max-w-2xl mx-auto">
          {t('landing.finalCta.subtitle')}
        </p>

        {/* Primary actions */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-10">
          <Button
            size="lg"
            onClick={onRegisterClick}
            className="bg-white text-primary hover:bg-secondary shadow-xl text-lg px-10 py-6 group"
            data-testid="final-cta-register-btn"
          >
            {t('landing.finalCta.ctaPrimary')}
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Button>
          <Button
            size="lg"
            variant="outline"
            className="border-2 border-white text-white hover:bg-white/10 text-lg px-10 py-6"
            onClick={onLoginClick}
            data-testid="final-cta-login-btn"
          >
            {t('landing.finalCta.ctaSecondary')}
          </Button>
        </div>

        {/* Divider */}
        <div className="flex items-center gap-4 max-w-sm mx-auto mb-8">
          <div className="flex-1 h-px bg-white/20" />
          <span className="text-white/50 text-xs uppercase tracking-widest">or</span>
          <div className="flex-1 h-px bg-white/20" />
        </div>

        {/* Waitlist capture */}
        <div className="max-w-md mx-auto">
          <WaitlistCapture variant="dark" source="final_cta" />
        </div>

        <p className="text-primary-foreground/60 mt-6 text-sm">
          {t('landing.finalCta.note')}
        </p>
      </div>
    </section>
  );
};

export default FinalCTASection;
